// PageExpense Component

import React from 'react'
import _ from 'lodash'

import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import List from '../../../../components/List/List.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import Button from '../../../common/common/button/button.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import ExpenseItem from '../../expense/expense_item/expense_item.jsx'
import ExpenseForm from '../../form/expense_form/expense_form.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import ReportPriceCell from '../../../report/report/report_pricecell/report_pricecell.jsx'
import DialogSpreadsheetExport from '../../../common/dialog/dialog_spreadsheet_export/dialog_spreadsheet_export.jsx'
import ExpenseUtil from '../../../lib/expenseutil.js'
import Acl from '../../../lib/acl.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import { ExpensesIcon } from '../../../common/layout/menu_icons/expenses.jsx'

import { getVatRateSelectOptionsFromArray } from '../../../lib/vat_rates_select_options.js'
import { getVatRatesForCountry } from '../../../../shared/util/vat'

class PageExpense extends PageBase {
  constructor (props) {
    super(props, 'expenses', 'expenses', 'expenses')

    this.state = {
      isLoading: true,
      dataDate: null,
      expense: null
    }

    this.data = {
      expenses: [],
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      sort: 'invoiceNo',
      sortAsc: true,
      pageNo: 1,
      pageState: {
        type: 'grid',
        sort: 'invoiceNo',
        sortAsc: true,
        filter: null
      },
      team: app.getTeam()
    }

    this._references = {
      header: React.createRef(),
      expenseSettingDialog: React.createRef(),
      confirmDelete: React.createRef(),
      expenseForm: React.createRef(),
      expenseExportDialog: React.createRef()
    }

    this._setFABButtonState(true, false)
    this._bUnMounted = false
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
    this._getData(false)
    this._initEvents()

    /* Load quickbook options for expense */
    ExpenseUtil.initQuickbookItems()
  }

  componentWillUnmount () {
    this._bUnMounted = true

    this._releaseEvents()
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)
  }

  renderContent () {
    return (
      <div className='pageinnercont'>
        {this._renderMessage()}
        {this._renderGridOrList()}
        {this._renderExpenseForm()}
        {this._renderSettingsDialog()}
        {this._renderExportDialog()}
      </div>
    )
  }

  _handleDocumentKeyDown = evt => {
    if (
      this.ignoreAutoSearch ||
      (this._references.expenseForm.current &&
        this._references.expenseForm.current.isActive()) ||
      (this._references.expenseExportDialog.current &&
        this._references.expenseExportDialog.current.isActive())
    ) {
      return
    }

    if (this._references.header.current) {
      const keyCode = evt.keyCode || 0

      let bSearch = true
      if (
        keyCode === 13 ||
        keyCode === 9 ||
        keyCode === 27 ||
        keyCode === 17 ||
        keyCode === 224
      ) {
        bSearch = false
      } else if (evt.ctrlKey || evt.altKey || evt.shiftKey || evt.metaKey) {
        bSearch = false
      }

      if (keyCode === 27) {
        this._references.header.current.onEscKeyDown()
      } else if (
        bSearch &&
        this._references.header.current &&
        this._references.header.current.canShowSearch()
      ) {
        this._references.header.current.showSearch()
      }
    }
  }

  getContentClassname () {
    return this.data.pageState.type === 'grid' ? 'alt' : null
  }

  /* Event handlers */
  onAdd () {
    const expense = {
      contactId: '',
      contactName: '',
      invoiceNo: '',
      invoiceDate: '',
      total: 0,
      subtotal: 0,
      diff: 0,
      description: '',
      items: [],
      attachment: []
    }

    if (this._references.expenseForm.current) {
      this._references.expenseForm.current.show(expense, false, [])
    }
  }

  _onGridItemClick (expense) {
    if (expense && expense.id) {
      ExpenseUtil.getExpenseDetails(expense.id, (expenseObj, items) => {
        if (expenseObj) {
          if (this._references.expenseForm.current) {
            this._references.expenseForm.current.show(expenseObj, true, items)
          }
        }
      })
    }
  }

  _onGridItemSettingClick (expense) {
    if (expense) {
      expense.contactName = expense.contact.company

      this.setState({ expense: expense })

      if (this._references.expenseSettingDialog.current) {
        this._references.expenseSettingDialog.current.show(
          expense.contact ? expense.contact.company : '',
          expense.invoiceNo,
          null,
          null
        )
      }
    }
  }

  _onSubView (projectId) {
    if (projectId) {
      app.changePage('projectview-budget', projectId)
    }
  }

  _onCloseSetting () {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }
  }

  _onEdit (expenseId, e) {
    e.preventDefault()

    if (expenseId) {
      if (this._references.expenseSettingDialog.current) {
        this._references.expenseSettingDialog.current.hide()
      }

      ExpenseUtil.getExpenseDetails(expenseId, (expense, items) => {
        if (expense) {
          if (this._references.expenseForm.current) {
            this._references.expenseForm.current.show(expense, true, items)
          }
        }
      })
    }
  }

  _onDelete (e) {
    e.preventDefault()

    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onClickDeleteConfirm (e) {
    if (!this.state.expense.id) {
      return false
    }

    e.preventDefault()
    app
      .service('/api/expense')
      .remove(this.state.expense.id)
      .then(_deleteRes => {
        if (this._references.expenseSettingDialog.current) {
          this._references.expenseSettingDialog.current.hide()
        }
        this.data.pageNo = 1
        this._reloadData()
      })
      .catch(deleteErr => {
        app.debug('PageExpense delete err', deleteErr)
      })
  }

  _onSaveExpense (
    expenseObj,
    expenseId,
    items,
    deletedItemIds,
    fileObj,
    bDeleteFile,
    closePoIds,
    newContactData,
    callback
  ) {
    const bSendQuickbook = expenseObj.bSendQuickbook

    if (expenseId) {
      ExpenseUtil.updateExpense(
        expenseObj,
        expenseId,
        items,
        deletedItemIds,
        fileObj,
        bDeleteFile,
        closePoIds,
        newContactData,
        updateErr => {
          if (updateErr) {
            app.debug('PageExpense updateErr', updateErr)
            if (updateErr.message === 'Invoice number already exists') {
              this.showError('expense.list.errorInvoiceNoAlreadyExists')
            } else if (updateErr.code >= 501 || updateErr.code <= 510) {
              this.showError(`expense.list.errorMsg${updateErr.code}`)
            } else {
              this.showError('expense.list.errorUpdateMsg')
            }
            callback(updateErr)
          } else {
            this._onAfterSave(false, bSendQuickbook, null, callback)
          }
        }
      )
    } else {
      ExpenseUtil.createExpense(
        expenseObj,
        items,
        deletedItemIds,
        fileObj,
        bDeleteFile,
        closePoIds,
        newContactData,
        (createErr, createRes) => {
          if (createErr) {
            app.debug('PageExpense createErr', createErr)
            if (createErr.message === 'Invoice number already exists') {
              this.showError('expense.list.errorInvoiceNoAlreadyExists')
            } else if (createErr.code >= 501 || createErr.code <= 510) {
              this.showError(`expense.list.errorMsg${createErr.code}`)
            } else {
              this.showError('expense.list.errorCreateMsg')
            }
            callback(createErr)
          } else {
            this._onAfterSave(true, bSendQuickbook, createRes.expense, callback)
          }
        }
      )
    }
  }

  _onSubmit (
    expenseObj,
    expenseId,
    items,
    deletedItemIds,
    fileObj,
    bDeleteFile,
    closePoIds,
    newContactData,
    callback
  ) {
    expenseObj.createdById = app.loggedInId

    this._onSaveExpense(
      expenseObj,
      expenseId,
      items,
      deletedItemIds,
      fileObj,
      bDeleteFile,
      closePoIds,
      newContactData,
      callback
    )
  }

  _openExpense (expenseId) {
    const expense = _.find(this.data.expenses, item => item.id === expenseId)
    if (expense) {
      this._onGridItemClick(expense)
    }
  }

  _onAfterSave (bCreateExpense, bSendQuickbook, expense, callback) {
    // If Quickbooks is not connected, close the form immediately
    // If expense is already sent to Quickbooks, close the form immediately
    if (!app.isQuickbookConnected() || !bSendQuickbook) {
      callback(null)

      if (this._references.expenseForm.current) {
        this._references.expenseForm.current.hide(false)
      }

      this._reloadData()
    } else {
      // If Quickbooks is connected, open form in edit mode,
      // and wait until the Quickbooks response comes
      /* if (bCreateExpense) {
        this._onGridItemClick(expense);
      } */

      if (this._references.expenseForm.current) {
        this._references.expenseForm.current.hide(false)
      }

      this._reloadData()
    }
  }

  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onExport () {
    if (this._references.expenseExportDialog.current) {
      this._references.expenseExportDialog.current.show()
    }
  }

  _onFilter (filter) {
    this.data.pageState.filter = filter

    if (filter.contentType !== this.data.pageState.type) {
      this.data.pageState.type = filter.contentType
      this.forceUpdate()
      this._updatePageState(this.data.pageState)
    } else {
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  _onCloseFilter () {
    this.data.pageState.filter.status = ''
    this.data.pageState.filter.supplier = null
    this.data.pageState.filter.datefilter = null
    this.data.pageState.filter.project = null
    this.data.pageState.filter.keyword = null
    this._reloadData()
  }

  /* _getData() {
    async.series([
      (done) => {
        this._getPageData(done);
      },
      (done) => {
        this._getDataExpense(done);
      }
    ], (err, _res) => {
      this._onDataReceived(err);
    });
  } */

  _getData (bReload) {
    app.debug('PageExpense: _getData [start]')

    const skip = (this.data.pageNo - 1) * 20
    const params = {
      query: {
        pageIdent: this._pageIdent,
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        expense: {
          $limit: 20,
          $skip: skip,
          $client: {
            subObjects: {
              contact: ['company', 'image', 'imageUrl'],
              items: []
            }
          }
        }
      }
    }

    app
      .service('/api/page/expense')
      .find(params)
      .then(result => {
        this._onPageDataRecieved(result.pageData)
        this.data.expenses =
          this.data.pageNo > 1
            ? this.data.expenses.concat(result.expenses)
            : result.expenses
        this.data.total = result.totalExpenses
        this.data.countLoaded = params.query.expense.$limit * this.data.pageNo
        this.data.canPaginate = !(this.data.countLoaded > this.data.total)

        this._onDataReceived(null)
      })
      .catch(err => {
        app.debug('PageExpense: _getData err', err)
        this._onDataReceived(err)
      })
  }

  /* _getDataExpense(callback) {
    app.debug('PageExpense: _getDataExpense [start]');

    const sort = this.data.pageState.sort;
    const sortAsc = this.data.pageState.sortAsc ? 1 : -1;
    const skip = (this.data.pageNo - 1) * 20;
    const params = {
      query: {
        $limit: 20,
        $skip: skip,
        $sort: { },
        $client: {
          subObjects: {
            'contact': ['company', 'image', 'imageUrl'],
            'items': []
          }
        }
      }
    };

    params.query.$sort[sort] = sortAsc;

    // Process Filters
    const filter = this.data.pageState.filter;
    let filterProject = null;
    if (filter) {
      if (filter.supplier) {
        params.query.contactId = filter.supplier.value;
      }

      if (filter.datefilter) {
        params.query.invoiceDate = { };
        if (filter.datefilter.value.from) {
          params.query.invoiceDate['$gte'] = new Date(filter.datefilter.value.from);
        }

        if (filter.datefilter.value.to) {
          params.query.invoiceDate['$lte'] = new Date(filter.datefilter.value.to);
        }
      }

      filterProject = filter.project;
    }

    this._getExpenseIdsByProject(filterProject, (expenseIds) => {
      if (expenseIds) {
        params.query._id = expenseIds;
      }

      app.service('/api/expense').find(params).then((result) => {
        this.data.expenses = this.data.pageNo > 1 ? this.data.expenses.concat(result.data) :
          result.data;
        this.data.total = result.total;
        this.data.countLoaded = params.query.$limit * this.data.pageNo;
        this.data.canPaginate = !(this.data.countLoaded > this.data.total);
        callback(null);
      }).catch((err) => {
        app.debug('PageExpense: _getDataExpense err', err);
        callback(err);
      });
    });
  } */

  _reloadData () {
    this._getData(true)
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        sort: pageState.sort || 'invoiceNo',
        sortAsc: pageState.sortAsc !== undefined ? pageState.sortAsc : true,
        type: pageState.type || 'grid',
        filter: pageState.filter || null
      }
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageExpense: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
    } else {
      // Process Project filter
      const filter = this.data.filter
      if (filter && filter.project) {
        if (this.data.expenses && this.data.expenses.length > 0) {
          this.data.expenses.map(expense => {
            const filterItem = _.find(
              expense.items,
              item => item.projectId === filter.project.value
            )
            if (filterItem) {
              _.remove(this.data.expenses, expObj => expObj.id !== expense.id)
            }
          })
        }
      }

      app.debug('PageExpense: _onDataReceived [done]')

      if (this.data.expenses && this.data.expenses.length > 0) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }
    }
    this.setState({ isLoading: false, dataDate: new Date() })
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this.data.pageNo = 1
    this._reloadData()
  }

  _getListColumns () {
    return [
      {
        label: 'expense.list.orderBySupplier',
        identifier: 'company',
        width: '40%',
        sort: false,
        filterType: 'autocomplete',
        type: 'text',
        field: 'contact'
      },
      {
        label: 'expense.list.orderByDate',
        identifier: 'invoiceDate',
        width: '15%',
        sort: true,
        filterType: 'date',
        type: 'date'
      },
      {
        label: 'expense.list.orderByInvoiceNo',
        identifier: 'invoiceNo',
        width: '30%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'expense.list.orderByAmount',
        identifier: 'total',
        width: '15%',
        sort: true,
        type: 'custom',
        customType: 'price'
      }
    ]
  }

  _getSortOptions () {
    return [
      // disabled until we fix the sort function
      // { label: 'expense.list.orderBySupplier', value: 'company' },
      { label: 'expense.list.orderByDate', value: 'invoiceDate' },
      { label: 'expense.list.orderByInvoiceNo', value: 'invoiceNo' },
      { label: 'expense.list.orderByAmount', value: 'total' }
    ]
  }

  _onSearchContact (keyword, callback) {
    this._onCommonFilterContactSearch(keyword, callback)
  }

  _onSearchProject (keyword, callback) {
    this._onCommonFilterProjectSearch(keyword, false, callback)
  }

  /* _getExpenseIdsByProject(project, callback) {
    if (!project) {
      callback(null);
    } else {
      const params = {
        query: {
          projectId: project.value,
          $select: ['expenseId']
        }
      };

      app.service('/api/expense/item').find(params).then((result) => {
        if (result.data.length > 0) {
          const filterExpenseIds = [];
          result.data.map(obj => {
            filterExpenseIds.push(obj.expenseId);
          });

          callback(filterExpenseIds);
        } else {
          callback([]);
        }
      }).catch((_err) => {
        callback(null);
      });
    }
  } */

  _onCloseForm () {
    if (this._references.expenseForm.current) {
      this._references.expenseForm.current.hide()
    }
  }

  /* Private functions */
  _onRenderList (expense, column, idx) {
    const value = expense[column.identifier]
    const width = column.width
    const showtooltip = expense[column.showtooltip]
    const estimatedMargin = expense[column.estimatedMargin]

    if (column.customType === 'price') {
      return (
        <ReportPriceCell
          price={value}
          width={width}
          showtooltip={showtooltip}
          key={idx}
          estimatedMargin={estimatedMargin}
        />
      )
    }

    return ''
  }

  _onRenderGrid (expense) {
    return (
      <ExpenseItem
        expense={expense}
        key={expense.id}
        isQuickbookConnected={app.isQuickbookConnected()}
        onView={this._onGridItemClick.bind(this)}
        onSetting={this._onGridItemSettingClick.bind(this)}
        onSubView={this._onSubView.bind(this)}
        useProjectNumber={app.projectSetting.useProjectNo}
      />
    )
  }

  _renderGridOrList () {
    if (this.state.isLoading || !this.data.expenses.length) {
      return null
    }

    let bShowLoader = false
    if (this.data.expenses && this.data.expenses.length < this.data.total) {
      bShowLoader = true
    }

    if (this.data.pageState.type === 'list') {
      return (
        <div className='listwrap'>
          <List
            objectList={this.data.expenses}
            sortOptions={this._getSortOptions()}
            columns={this._getListColumns()}
            onPaginate={this._onPaginate.bind(this)}
            onSort={this._onSort.bind(this)}
            renderCustomCell={this._onRenderList.bind(this)}
            onView={this._onGridItemClick.bind(this)}
            actionIcon='common-action-setting'
            sort={this.data.pageState.sort}
            sortAsc={this.data.pageState.sortAsc}
            showLoader={bShowLoader}
            onSettings={this._onGridItemSettingClick.bind(this)}
          />
          {this._renderExportDialog()}
        </div>
      )
    }

    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.expenses}
          sortOptions={this._getSortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
          showLoader={bShowLoader}
          onSort={this._onSort.bind(this)}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
        {this._renderExportDialog()}
      </div>
    )
  }

  _renderSettingsDialog () {
    const { expense, loading } = this.state
    if (loading) {
      return ''
    }

    const bDisable = !Acl.isRoleFinance()
    const colDeleteClass = bDisable
      ? 'actionboard-col2 alert-col2 confirm alt disabled'
      : 'actionboard-col2 alert-col2 confirm alt'

    return (
      <DialogSetting
        ref={this._references.expenseSettingDialog}
        onClose={this._onCloseSetting.bind(this)}
      >
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onEdit.bind(this, expense ? expense.id : null)}
            >
              <Button
                icon='action-edit'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.actionEdit' />
              </span>
            </div>
          </div>
          <div className={colDeleteClass}>
            <div
              className='action-btn'
              onClick={!bDisable ? this._onDelete.bind(this) : null}
            >
              <Button
                icon='action-delete'
                className='button_dialog button_dialogdlt'
                canHover={false}
                tooltipPosition='bottom'
                tooltip={bDisable ? 'expense.list.tipDelete' : ''}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.actionDelete' />
              </span>
            </div>
            <ConfirmDelete
              ref={this._references.confirmDelete}
              title='expense.list.msgOnDelete'
              onClickOk={this._onClickDeleteConfirm.bind(this)}
            />
          </div>
        </div>
        {expense && expense.attachment && (
          <div className='actionboard-row act-row'>
            <div className='actionboard-col2 alert-col2'>
              <div className='action-btn'>
                <a
                  className='action-link'
                  href={encodeURI(
                    `/expense/preview/${expense.teamId}/${expense.attachment.fileName}/${expense.attachment.name}`
                  )}
                  target='_blank'
                  rel='noopener noreferrer'
                />
                <Button
                  icon='action-attachment'
                  className='button_dialog'
                  canHover={false}
                />
                <span className='label'>
                  <IntlMessage ident='expense.list.actionOpenAttachment' />
                </span>
              </div>
            </div>
          </div>
        )}
      </DialogSetting>
    )
  }

  _renderExpenseForm () {
    const vatLevels =
      this.data.team && this.data.team.profile
        ? getVatRateSelectOptionsFromArray(
          getVatRatesForCountry(this.data.team.profile.country)
        )
        : []

    return (
      <ExpenseForm
        ref={this._references.expenseForm}
        onSubmit={this._onSubmit.bind(this)}
        onValidateInvoiceNo={ExpenseUtil.validateInvoiceNo} // eslint-disable-line react/jsx-handler-names
        contactsearch={this._onSearchContact.bind(this)} // eslint-disable-line react/jsx-handler-names
        getProjects={ExpenseUtil.getProjects}
        showError={this.showError.bind(this)}
        getContactBudgetItems={ExpenseUtil.getContactBudgetItems}
        onAddBudgetExpense={ExpenseUtil.onAddBudgetExpense} // eslint-disable-line react/jsx-handler-names
        onSelectBudgetExpense={ExpenseUtil.onSelectBudgetExpense} // eslint-disable-line react/jsx-handler-names
        onSearchBudgetItem={ExpenseUtil.getProjectBudgetItems} // eslint-disable-line react/jsx-handler-names
        onClose={this._onCloseForm.bind(this)}
        onCreateContact={ExpenseUtil.onCreateContact} // eslint-disable-line react/jsx-handler-names
        attachment={
          this.data.team.integration && this.data.team.integration.isAttached
        }
        validateExpenseTotalWithPO={ExpenseUtil.validateExpenseTotalWithPO}
        uploadError={this._onExpenseUploadError.bind(this)}
        vatLevels={vatLevels}
        defaultVat={app.getDefaultVat()}
        showVat={app.isVatSupportedInCountry(app.teamCountry)}
        isQuickbookConnected={app.isQuickbookConnected()}
        getQuickbookItems={ExpenseUtil.getQuickbookItems}
        reloadQuickbookItems={ExpenseUtil.reloadQuickbookItems}
      />
    )
  }

  _renderMessage () {
    if (!this.state.isLoading && !this.data?.expenses?.length) {
      return (
        <ContentMessage
          message='expense.list.msgNoExpenseFoundTitle'
          info='expense.list.msgNoExpenseFoundInfo'
          showAddPrefix
          showAdd
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return null
  }

  _onExpenseUploadError (message) {
    if (message) {
      this.showError('common.form.uploadError')
    }
  }

  _renderExportDialog () {
    return (
      <DialogSpreadsheetExport
        ref={this._references.expenseExportDialog}
        noExpense={this.data.total}
        onExportExcel={this._onClickExport.bind(this, 'xlsx')}
        onExportCsv={this._onClickExport.bind(this, 'csv')}
        i18nTitleKey='expense.list.exportTitle'
        i18nSubTitleKey='expense.list.subTitle'
      />
    )
  }

  _onClickExport (exportFileType, e) {
    e.preventDefault()
    const data = {
      userId: app.loggedInId,
      exportFileType
    }

    const exportParams = {
      query: {
        pageIdent: this._pageIdent,
        pageState: this.data.pageState,
        bUpdatePageState: false,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
        expense: {
          $client: {
            subObjects: {
              contact: ['company', 'image', 'imageUrl'],
              items: []
            }
          }
        }
      }
    }

    app
      .service('/api/expense/export')
      .create(data, exportParams)
      .then(downloadPath => app.redirect(downloadPath))
      .catch(err => {
        app.debug('PageExpense: onClickExport error', err)
      })
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.expenseCreated = this._eventReload.bind(
      this,
      'Expense',
      'Created'
    )
    this._eventHandlers.expenseUpdated = this._eventReload.bind(
      this,
      'Expense',
      'Updated'
    )
    this._eventHandlers.expenseRemoved = this._eventReload.bind(
      this,
      'Expense',
      'Removed'
    )
    this._eventHandlers.expensePatched = this._eventReload.bind(
      this,
      'Expense',
      'Patched'
    )

    const expenseService = app.service('/api/expense')
    expenseService.on('created', this._eventHandlers.expenseCreated)
    expenseService.on('updated', this._eventHandlers.expenseUpdated)
    expenseService.on('removed', this._eventHandlers.expenseRemoved)
    expenseService.on('patched', this._eventHandlers.expensePatched)

    /* Init quickbook events */
    this._initQuickbookExpenseEvents()
  }

  _releaseEvents () {
    const expenseService = app.service('/api/expense')
    expenseService.off('created', this._eventHandlers.expenseCreated)
    expenseService.off('updated', this._eventHandlers.expenseUpdated)
    expenseService.off('removed', this._eventHandlers.expenseRemoved)
    expenseService.off('patched', this._eventHandlers.expensePatched)

    this._eventHandlers.expenseService = null
    this._eventHandlers.expenseService = null
    this._eventHandlers.expenseService = null
    this._eventHandlers.expenseService = null

    /* Release quickbook events */
    this._releaseQuickbookExpenseEvents()
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageExpense - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  /* Header Functions - START */
  renderHeader () {
    const { pageState } = this.data
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const lastWeekStartDate = DateUtil.getMondayByDate(new Date())
    lastWeekStartDate.setDate(lastWeekStartDate.getDate() - 7)
    const filter = pageState.filter || {}
    const actions = [
      {
        ident: 'export',
        icon: 'download-solid',
        tooltip: 'contact.list.tipExport',
        tooltipPosition: 'bottom',
        onClick: this._onExport.bind(this)
      }
    ]

    const filters = [
      {
        type: 'label',
        label: 'expense.list.filterPaid'
      },
      {
        ident: 'project',
        type: 'tag',
        label: 'expense.list.filterProjects',
        placeholder: 'expense.list.placeholderSearchProject',
        isMulti: false,
        value: filter.project || null
      },
      {
        type: 'label',
        label: 'expense.list.filterLabelTo'
      },
      {
        ident: 'supplier',
        type: 'tag',
        label: 'expense.list.filterSuppliers',
        placeholder: 'expense.list.placeholderSearchSuppliers',
        isMulti: false,
        value: filter.supplier || null
      },
      {
        ident: 'datefilter',
        type: 'date',
        label: 'expense.list.allPeriods',
        isMulti: true,
        value: filter.datefilter || null,
        dateOptions: [
          {
            ident: 'last-week',
            label: 'expense.list.filterDateWeek',
            value: {
              from: DateUtil.getUTCDateFromDate(lastWeekStartDate),
              to: DateUtil.getUTCDateFromTime(
                lastWeekStartDate.getTime() + 1000 * 7 * 24 * 60 * 60
              )
            }
          },
          {
            ident: 'last-month',
            label: 'expense.list.filterDateMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth - 1, 1),
              to: DateUtil.getUTCDate(currYear, currMonth, 0, 23, 59, 59)
            }
          },
          {
            ident: 'this-month',
            label: 'expense.list.filterDateThisMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth, 1),
              to: DateUtil.getUTCDate(currYear, currMonth + 1, 0, 23, 59, 59)
            }
          },
          {
            ident: 'this-year',
            label: 'expense.list.filterDateYear',
            value: {
              from: DateUtil.getUTCDate(currYear, 0, 1),
              to: DateUtil.getUTCDate(currYear, 11, 31, 23, 59, 59)
            }
          },
          {
            ident: 'last-year',
            label: 'expense.list.filterDateLastYear',
            subtitle: currYear - 1,
            value: {
              from: DateUtil.getUTCDate(currYear - 1, 0, 1),
              to: DateUtil.getUTCDate(currYear - 1, 11, 31, 23, 59, 59)
            }
          }
        ]
      }
    ]

    const filterActions = [
      {
        ident: 'export',
        icon: 'download',
        tooltip: 'report.view.tipDownloadReport',
        tooltipPosition: 'bottom',
        className: 'filterdownload',
        type: 'invert',
        onClick: this._onExport.bind(this)
      }
    ]

    return (
      <PageHeader
        ref={this._references.header}
        title='expense.list.labelExpenses'
        icon={<ExpensesIcon width={25} />}
        hasFilter
        hasSearch
        showTabs
        activeTab='expenses'
        favoriteTab={this._getUserFavoriteTab('expanse') || 'expenses'}
        tabs={[
          {
            ident: 'expenses',
            title: 'expense.list.labelExpenses',
            showFavourite: true
          },
          {
            ident: 'purchaseorders',
            title: 'expense.list.labelTitlePo',
            showFavourite: true
          }
        ]}
        filters={filters}
        filterActions={filterActions}
        actions={actions}
        showGridList
        isGridActive={pageState.type === 'grid'}
        keywordSearch={filter.keyword}
        placeholderSearch='expense.list.searchPlaceholder'
        onGridListToggle={this._onHeaderGridListToggle.bind(this)}
        onChange={this._onHeaderChangeFilter.bind(this)}
        onSearchTags={this._onHeaderSearchTags.bind(this)}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderGridListToggle (isGridActive) {
    this.data.pageState.type = isGridActive ? 'grid' : 'list'
    this._updatePageState(this.data.pageState)

    this.setState({ dataDate: new Date() })
  }

  _onHeaderChangeFilter (filter) {
    this.data.pageState.filter = filter
    this.data.pageNo = 1

    this._reloadData()
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'project') {
      this._onCommonFilterProjectSearch(keyword, false, callback)
    } else if (filterIdent === 'supplier') {
      this._onCommonFilterContactSearch(keyword, callback)
    }
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('expanse', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions - END */
}

export default PageExpense
